<template>
  <RevTable
    id="financeReportMetricsTable"
    class="mt-32"
    :collection="metrics"
    :columns
    transparent-header
  >
    <template #body-metric="{ item }">
      <RevTooltip class="ml-16 mr-2" position="top">
        <template v-if="item.code !== 'TOTAL'" #trigger="{ show, hide }">
          <IconInfo
            class="mr-4"
            color="secondary"
            size="16"
            @focusin="show"
            @focusout="hide"
            @mouseenter="show"
            @mouseleave="hide"
          />
        </template>
        {{ item.tooltip }}
      </RevTooltip>
      {{ item.label }}
    </template>
  </RevTable>
</template>

<script lang="ts" setup>
import type { FinancialReportMetric } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/financial-report.types'
import { RevTable } from '@ds/components/Table'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'

defineProps<{
  metrics: FinancialReportMetric[]
}>()

const columns = [
  {
    key: 'metric',
    label: '',
  },
]
</script>
